import Shirt from '../Assets/template/shirt2.png'

export const templates = [
    {
        id: 1,
        name: 'Template 1',
        elements: [
            {
                type: 'image',
                url: Shirt,
                options: { left: 112, top: 50, scale: 0.5, zIndex: 100, width: 500, height: 500 },
            },
            {
                type: 'textbox',
                text: 'SMILE',
                options: { left: 330, top: 230, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 130, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'AND',
                options: { left: 360, top: 260, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 130, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'WIN',
                options: { left: 330, top: 290, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontWeight: 'bold', fontStyle: 'italic', zIndex: 2000, width: 130, lineHeight: 1 },
            },
        ],
    },
    {
        id: 2,
        name: 'Template 2',
        elements: [
            {
                type: 'image',
                url: Shirt,
                options: { left: 112, top: 50, scale: 0.5, zIndex: 100, width: 500, height: 500 },
            },
            {
                type: 'textbox',
                text: 'SLEEP',
                options: { left: 330, top: 230, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 130, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'MADE',
                options: { left: 360, top: 260, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 130, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'EASY',
                options: { left: 330, top: 290, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontWeight: 'bold', fontStyle: 'italic', zIndex: 2000, width: 130, lineHeight: 1 },
            },
        ],
    },
    {
        id: 3,
        name: 'Template 3',
        elements: [
            {
                type: 'image',
                url: Shirt,
                options: { left: 112, top: 50, scale: 0.5, zIndex: 100, width: 500, height: 500 },
            },
            {
                type: 'textbox',
                text: 'STAND UP',
                options: { left: 280, top: 230, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 180, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'FOR THE',
                options: { left: 310, top: 260, fill: '#000000', fontSize: 25, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 130, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'CHAMPION',
                options: { left: 280, top: 290, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontWeight: 'bold', fontStyle: 'italic', zIndex: 2000, width: 130, lineHeight: 1 },
            },
        ],
    },
    {
        id: 4,
        name: 'Template 4',
        elements: [
            {
                type: 'image',
                url: Shirt,
                options: { left: 112, top: 50, scale: 0.5, zIndex: 100, width: 500, height: 500 },
            },
            {
                type: 'textbox',
                text: 'BE',
                options: { left: 340, top: 230, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 180, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'BOLD',
                options: { left: 330, top: 260, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 130, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'AS A',
                options: { left: 330, top: 290, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontWeight: 'bold', fontStyle: 'italic', zIndex: 2000, width: 130, lineHeight: 1 },
            },
            {
                type: 'textbox',
                text: 'LION',
                options: { left: 330, top: 320, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontWeight: 'bold', fontStyle: 'italic', zIndex: 2000, width: 130, lineHeight: 1 },
            },
        ],
    },
    {
        id: 5,
        name: 'Template 5',
        elements: [
            {
                type: 'image',
                url: Shirt,
                options: { left: 112, top: 50, scale: 0.5, zIndex: 100, width: 500, height: 500 },
            },
            {
                type: 'textbox',
                text: 'ENDURANCE',
                options: { left: 265, top: 230, fill: '#000000', fontSize: 30, fontFamily: 'Arial', fontStyle: 'italic', fontWeight: 'bold', zIndex: 2000, width: 180, lineHeight: 1 },
            },
        ],
    },
    // Add more templates as needed
]